import { module } from 'modujs';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.list = this.el.querySelector('ul');
        this.count = this.list.querySelectorAll('li').length;
        this.children = this.list.childNodes;
    }

    updateTitle(e) {
        if (e.way == 'enter') {
            let elt = this.list.querySelector('li[data-section="' + e.target.getAttribute('data-section') + '"]');
            let index = this.indexInParent(elt);
            if (index >= 0) {
                gsap.set(
                    this.list,
                    { y: (-100 * (index / this.count)) + '%' }
                )
            }
        }
    }

    indexInParent(node) {
        let num = 0;
        for (let i=0; i<this.children.length; i++) {
             if (this.children[i]==node) return num;
             if (this.children[i].nodeType==1) num++;
        }
        return -1;
    }
}
